import Link from "next/link";

import useCanDoShop from "../../hooks/useCanDoShop.hook";

export default function SolidLink({
  id,
  href,
  text,
  icon,
  className,
  cap,
}: {
  id?: string;
  href: string;
  text: string;
  icon?: React.ReactNode;
  className?: string;
  cap?: ShopCap;
}) {
  const canDo = useCanDoShop(cap);

  if (canDo) {
    return (
      <Link
        id={id}
        href={href}
        className={`${
          className ?? ""
        } bg-her-dodgerblue text-white px-2 py-1 rounded-md cursor-pointer inline-flex gap-2 items-center`}
      >
        {icon}
        {text}
      </Link>
    );
  }

  return (
    <div
      id={id}
      className={`${
        className ?? ""
      } bg-her-aaa text-white dark:bg-her-lightgray2 dark:text-her-aaa px-2 py-1 rounded-md inline-flex gap-2 items-center`}
    >
      {icon}
      {text}
    </div>
  );
}
